export default __webpack_public_path__ + "static/selfapp-screens-855d900345b8d0416cb452741e06c29c.jpg";